import * as React from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";

import { routes } from "@/routes";
import { Root } from "@/root";
import { ScrollRestoration } from "@/components/core/scroll-restoration";

import "./styles/navbar.css";
//import { AppErrorBoundary } from "./error";


const root = createRoot(document.querySelector("#root")!);

const router = createBrowserRouter([
	{
		path: "/",
        element: (
            //<AppErrorBoundary>
                <Root>
               {/*    <BrowserMemoryDebugLogger />*/}
				    <ScrollRestoration />
				    <Outlet />
                </Root>
            //</AppErrorBoundary>
		),
		children: [...routes],
	},
]);

root.render(
	<React.StrictMode>
		<RouterProvider router={router} />
	</React.StrictMode>
);
